module.exports = __webpack_public_path__ + "img/metaverse-box.d8f125cd.svg";